<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2"><i class="fa-solid fa-house me-2"></i>Mein Dashboard</h1>
    <!--<div class="btn-toolbar mb-2 mb-md-0">
        <div class="btn-group me-2">
            <button type="button" class="btn btn-sm btn-outline-secondary">Share</button>
            <button type="button" class="btn btn-sm btn-outline-secondary">Export</button>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar align-text-bottom" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
            This week
        </button>
    </div>-->
</div>

<div class="row row-cols-1 row-cols-md-4 g-4 mb-4 text-center" *ngIf="stats">
    <div class="col">
        <div class="card text-white bg-danger" (click)="showStatus('new')">
            <div class="card-body">
                <h4 class="card-title">{{stats.new}}</h4>
                <p class="card-text">Neu</p>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card text-dark bg-warning" (click)="showStatus('in_progress')">
            <div class="card-body">
                <h4 class="card-title">{{stats.in_progress}}</h4>
                <p class="card-text">In Bearbeitung</p>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card text-white bg-success" (click)="showStatus('done')">
            <div class="card-body">
                <h4 class="card-title">{{stats.done}}</h4>
                <p class="card-text">Erledigt</p>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card text-white bg-secondary" (click)="showStatus('cancelled')">
            <div class="card-body">
                <h4 class="card-title">{{stats.cancelled}}</h4>
                <p class="card-text">Abgesagt</p>
            </div>
        </div>
    </div>
</div>

<div class="text-center">
    <button type="button" class="btn btn-primary btn-lg mb-3" [routerLink]="['/task', 0]">Aufgabe anlegen</button>
</div>

<h3 class="h4">Neue Aufgaben ({{data.new?.length}})</h3>

<p *ngIf="data.new?.length == 0">Keine neue Aufgaben</p>

<div class="table-responsive">
    <table *ngIf="data.new?.length > 0" class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th>#</th>
            <th>Titel</th>
            <th style="width: 100px">Status</th>
            <th style="width: 130px">Erstellt am</th>
            <th>Kunde</th>
            <th>Kontakt</th>
            <th style="width: 100px">Fälligkeit</th>
            <th style="width: 170px">Abteilung</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of data.new" [routerLink]="['/task', entry.id]">
            <td>{{ entry.id }}</td>
            <td>{{ entry.title }}</td>
            <td>
                <i class="fa-solid fa-circle text-danger"></i>
                {{ 'new' | status }}
            </td>
            <td>{{ entry.created_at | date: 'dd.MM.yyyy HH:mm'}}</td>
            <td>
                {{ entry.customer }}
                <span class="text-muted" *ngIf="!entry.customer">Nicht gesetzt</span>
            </td>
            <td>
                {{ entry.contact }}
                <span class="text-muted" *ngIf="!entry.contact">Nicht gesetzt</span>
            </td>
            <td>
                <i class="fa fa-exclamation-triangle text-danger" *ngIf="entry.due_date_past"></i>
                {{ entry.due_date | date: 'dd.MM.yyyy' }}
            </td>
            <td>
                {{ entry.department }}
                <span class="text-muted" *ngIf="!entry.department">Nicht gesetzt</span>
            </td>
        </tr>
        </tbody>
    </table>
</div>

<h3 class="h4">Aufgaben in Bearbeitung ({{data.in_progress?.length}})</h3>

<p *ngIf="data.in_progress?.length == 0">Keine Aufgaben in Bearbeitung</p>

<div class="table-responsive">
    <table *ngIf="data.in_progress?.length > 0" class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th>#</th>
            <th>Titel</th>
            <th style="width: 100px">Status</th>
            <th style="width: 130px">Erstellt am</th>
            <th>Kunde</th>
            <th>Kontakt</th>
            <th style="width: 100px">Fälligkeit</th>
            <th style="width: 170px">Abteilung</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of data.in_progress" [routerLink]="['/task', entry.id]">
            <td>{{ entry.id }}</td>
            <td>{{ entry.title }}</td>
            <td>
                <i class="fa-solid fa-circle text-warning"></i>
                {{ 'in_progress' | status }}
            </td>
            <td>{{ entry.created_at | date: 'dd.MM.yyyy HH:mm'}}</td>
            <td>
                {{ entry.customer }}
                <span class="text-muted" *ngIf="!entry.customer">Nicht gesetzt</span>
            </td>
            <td>
                {{ entry.contact }}
                <span class="text-muted" *ngIf="!entry.contact">Nicht gesetzt</span>
            </td>
            <td>
                <i class="fa fa-exclamation-triangle text-danger" *ngIf="entry.due_date_past"></i>
                {{ entry.due_date | date: 'dd.MM.yyyy' }}
            </td>
            <td>
                {{ entry.department }}
                <span class="text-muted" *ngIf="!entry.department">Nicht gesetzt</span>
            </td>
        </tr>
        </tbody>
    </table>
</div>

<h3 class="h4">Zuletzt abgeschlossene Aufgaben (letzten {{data.completed?.length}})</h3>

<div class="table-responsive">
    <table *ngIf="data.completed?.length > 0" class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th>#</th>
            <th>Titel</th>
            <th style="width: 100px">Status</th>
            <th style="width: 130px">Erstellt am</th>
            <th>Kunde</th>
            <th>Kontakt</th>
            <th style="width: 100px">Fälligkeit</th>
            <th style="width: 170px">Abteilung</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of data.completed" [routerLink]="['/task', entry.id]">
            <td>{{ entry.id }}</td>
            <td>{{ entry.title }}</td>
            <td>
                <i class="fa-solid fa-circle"
                   [class.text-success]="entry.status == 'done'"
                   [class.text-secondary]="entry.status == 'cancelled'"
                ></i>
                {{ entry.status | status }}
            </td>
            <td>{{ entry.created_at | date: 'dd.MM.yyyy HH:mm'}}</td>
            <td>
                {{ entry.customer }}
                <span class="text-muted" *ngIf="!entry.customer">Nicht gesetzt</span>
            </td>
            <td>
                {{ entry.contact }}
                <span class="text-muted" *ngIf="!entry.contact">Nicht gesetzt</span>
            </td>
            <td>{{ entry.due_date | date: 'dd.MM.yyyy' }}</td>
            <td>
                {{ entry.department }}
                <span class="text-muted" *ngIf="!entry.department">Nicht gesetzt</span>
            </td>
        </tr>
        </tbody>
    </table>
</div>
